// extracted by mini-css-extract-plugin
export default {"Toolbar":"Toolbar_Toolbar__wyFyE","Logo":"Toolbar_Logo__Oyl1U","DesktopOnly":"Toolbar_DesktopOnly__QdikG"};